import { IUserContext } from 'models/user'
import { useContext } from 'react'
import { AuthContext } from '../hoc/AuthProvider'

export const useAuth = (): IUserContext => useContext(AuthContext)
